// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mailing-item-info__image-block-input-hidden {
    display: none;
}

.mailing-item-info__image-block-input-field {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-grow: 1;
    width: 100%;
    min-width: 0;
}

.remove-image-button {
    height: 2.4rem;
    cursor: pointer;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mailing-item-info__image-block {
    margin-top: 1.4rem;
    float: left;
    width: 65%;
    border-bottom: 1px solid #9e9e9e;
    padding-bottom: 0.1rem;
}
.mailing-item-info__image-block-input-field-label {
    background-color: #26a69a;
    color: white;
    letter-spacing: .5px;
    font-size: 1.2rem;
    border: none;
    border-radius: 2px;
    padding: 0.6rem 1.6rem;
    cursor: pointer;
    text-transform: uppercase;
    white-space: nowrap;
    flex-shrink: 0;
}
.mailing-item-info__image-block-input-field-label:hover {
    background-color: #2bbbad;
}

.uploaded-image__file-name {
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 10rem;
    margin-top: 1.55px;
}

.file-name-row {
    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-grow: 1;
    min-width: 0;
}

.mailing-item-info__image {
    min-width: 110rem;
}

.material-icons.remove-image-button {
    color: #666666;
    transition: all 0.2s ease-in-out;
}

    .material-icons.remove-image-button:hover {
        color: #fff;
        background: #26a69a;
    }`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/mailing-item-info/CreateMailingInfo/MailingImageUploader/MailingImageUploader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gCAAgC;IAChC,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;IAEI;QACI,WAAW;QACX,mBAAmB;IACvB","sourcesContent":[".mailing-item-info__image-block-input-hidden {\r\n    display: none;\r\n}\r\n\r\n.mailing-item-info__image-block-input-field {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    flex-grow: 1;\r\n    width: 100%;\r\n    min-width: 0;\r\n}\r\n\r\n.remove-image-button {\r\n    height: 2.4rem;\r\n    cursor: pointer;\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.mailing-item-info__image-block {\r\n    margin-top: 1.4rem;\r\n    float: left;\r\n    width: 65%;\r\n    border-bottom: 1px solid #9e9e9e;\r\n    padding-bottom: 0.1rem;\r\n}\r\n.mailing-item-info__image-block-input-field-label {\r\n    background-color: #26a69a;\r\n    color: white;\r\n    letter-spacing: .5px;\r\n    font-size: 1.2rem;\r\n    border: none;\r\n    border-radius: 2px;\r\n    padding: 0.6rem 1.6rem;\r\n    cursor: pointer;\r\n    text-transform: uppercase;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n}\r\n.mailing-item-info__image-block-input-field-label:hover {\r\n    background-color: #2bbbad;\r\n}\r\n\r\n.uploaded-image__file-name {\r\n    overflow-x: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    min-width: 10rem;\r\n    margin-top: 1.55px;\r\n}\r\n\r\n.file-name-row {\r\n    gap: 0.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-grow: 1;\r\n    min-width: 0;\r\n}\r\n\r\n.mailing-item-info__image {\r\n    min-width: 110rem;\r\n}\r\n\r\n.material-icons.remove-image-button {\r\n    color: #666666;\r\n    transition: all 0.2s ease-in-out;\r\n}\r\n\r\n    .material-icons.remove-image-button:hover {\r\n        color: #fff;\r\n        background: #26a69a;\r\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
